import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import FormError from "../../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

class ProductPricingForm extends Component {

  render() {
    let {errors, handleSubmit, submit, pricing, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    let currencyFields = pricing.map(x => {
      return (
        <Field 
          key={x.get("currency")}
          label={x.get("currency")}
          name={`pricing[${x.get("currency")}]`}
          serverError={this.props.errors.pricing}
          component={TextInputField}
          normalize={numerical}
          />
      )
    });

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            {currencyFields}
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "ProductPricingForm"
})(ProductPricingForm);

export default ReduxForm;